<template>
  <v-page-content>
    <v-all-events editMode></v-all-events>
  </v-page-content>
</template>

<script>
const VAllEvents = () => import('@/components/content/events/AllEvents.vue')

export default {
  name: 'EditEvents',
  components: {
    VAllEvents
  }
}
</script>

<style scoped>

</style>
